/* UNTAMED MOTOSPORTS — theme behaviour
   Mobile menu, scroll reveal, product gallery, quantity stepper. */
(function () {
  'use strict';

  /* ---- Mobile menu ---- */
  var burger = document.getElementById('burger');
  var mm = document.getElementById('mobileMenu');
  if (burger && mm) {
    burger.addEventListener('click', function () { mm.classList.toggle('open'); });
    mm.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mm.classList.remove('open'); });
    });
  }

  /* ---- Reveal on scroll ---- */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- Product gallery (thumbnail swap) ---- */
  var gallery = document.querySelector('.gallery');
  if (gallery) {
    var mainImg = gallery.querySelector('.main img');
    gallery.querySelectorAll('.thumbs button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (full && mainImg) { mainImg.src = full; }
        gallery.querySelectorAll('.thumbs button').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  }

  /* ---- Quantity stepper ---- */
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    if (!input) return;
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (b.getAttribute('data-dir') === 'up') v += 1;
        else v = Math.max(1, v - 1);
        input.value = v;
      });
    });
  });
})();
